import { compose } from 'redux';
import { connect } from 'react-redux';
import { withProps } from 'recompose';
import { withScriptjs, withGoogleMap } from 'react-google-maps';

import config from 'config/index';
import { actions as pinsActions, selectors as pinsSelectors } from 'modules/pins';

import Map, { ContainerElement, MapElement, LoadingElement } from '../components/Map';

import { selectPins, selectMapActivePinId } from '../services/selectors';

const { setNewPin } = pinsActions;

export default compose(
    connect(
        state => ({
            newPin: pinsSelectors.selectNewPin(state),
            pins: selectPins(state),
            activePinId: selectMapActivePinId(state),
        }),
        dispatch => ({
            handleClick: e => {
                const payload = {
                    lat: e.latLng.lat(),
                    lng: e.latLng.lng(),
                };
                dispatch(setNewPin(payload));
            },
        }),
    ),
    withProps({
        googleMapURL: config.googleMaps.url,
        loadingElement: LoadingElement,
        containerElement: ContainerElement,
        mapElement: MapElement,
    }),
    withScriptjs,
    withGoogleMap,
)(Map);
